import OnScrollto from './src/on-scrollto-directive';

/* istanbul ignore next */
OnScrollto.install = function(Vue) {
    Vue.directive(OnScrollto.name, OnScrollto);
};

export default OnScrollto;
